import { lazy } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

const Chat = lazy(() => import('./pages/chat'));
const Directory = lazy(() => import('./pages/directory'));
const DirectoryDetail = lazy(() => import('./pages/directory/detail'));
const Index = lazy(() => import('./pages/home'));
const MallIndex = lazy(() => import('./pages/home/mall'));
const Register = lazy(() => import('./pages/users/register'));
const Profile = lazy(() => import('./pages/users/profile'));
const Rewards = lazy(() => import('./pages/rewards'));
const RewardsDetail = lazy(() => import('./pages/rewards/detail'));
const RewardsMyVoucher = lazy(() => import('./pages/rewards/detailMyVoucher'));
const Event = lazy(() => import('./pages/event'));
const Layout = lazy(() => import('./layouts'));

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path={`${process.env.PUBLIC_URL}/chat`} element={<Chat />} />
          <Route path={`${process.env.PUBLIC_URL}/directory`} element={<Directory />} />
          <Route path={`${process.env.PUBLIC_URL}/directory/:slug`} element={<DirectoryDetail />} />
          <Route path={`${process.env.PUBLIC_URL}/event/:slug`} element={<Event />} />
          <Route path={`${process.env.PUBLIC_URL}/rewards`} element={<Rewards />} />
          <Route path={`${process.env.PUBLIC_URL}/rewards/myvoucher`} element={<RewardsMyVoucher />} />
          <Route path={`${process.env.PUBLIC_URL}/rewards/:slug`} element={<RewardsDetail />} />
          <Route path={`${process.env.PUBLIC_URL}/user/profile`} element={<Profile />} />
          <Route path={`${process.env.PUBLIC_URL}/user/register`} element={<Register />} />
          <Route path={`${process.env.PUBLIC_URL}/user/register/otp`} element={<Register />} />
          <Route path={`${process.env.PUBLIC_URL}/user/register/profile`} element={<Register />} />
          <Route path={`${process.env.PUBLIC_URL}/user/register/final`} element={<Register />} />
          <Route path={`${process.env.PUBLIC_URL}/mall`} element={<MallIndex />} />
          <Route path={`${process.env.PUBLIC_URL}/`} element={<Index />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
